import { httpClient } from './httpClient';
import { PortalSummarySchema, type PortalSummary } from './schemas/portal';

/**
 * C4 — fachada do resumo do portal. A contagem dos badges e a régua de pendências vêm SOMENTE
 * do servidor (`GET /companies/{companyId}/portal-summary`) — contagem no cliente é proibida
 * (plano web §4). A rota do `route` da pendência é emitida pelo servidor e o router a aceita
 * como deep link.
 */
export async function fetchPortalSummary(companyId: string): Promise<PortalSummary> {
  const payload: unknown = await httpClient.get(`/companies/${companyId}/portal-summary`);
  const parsed = PortalSummarySchema.safeParse(payload);
  if (!parsed.success) throw new Error('Resumo do portal em formato inesperado.');
  return parsed.data;
}
